(function () {
  function init(form) {
    if (form.dataset.widerrufBound) return;
    form.dataset.widerrufBound = '1';

    const wrapper = form.closest('.widerruf') || document;
    const sentBox = wrapper.querySelector('[data-widerruf-sent]');
    const errorBox = wrapper.querySelector('[data-widerruf-error]');
    const submitBtn = form.querySelector('[type="submit"]');
    const elapsedField = form.querySelector('[data-widerruf-elapsed]');
    const endpoint = form.getAttribute('action') || '/apps/widerruf';

    // Zeitpunkt des Formular-Aufbaus — für den Bot-Zeit-Check
    const loadedAt = Date.now();

    form.addEventListener('submit', async function (event) {
      event.preventDefault();

      // Verstrichene Zeit seit Seitenaufbau (gleiche Uhr → keine Server-Diskrepanz)
      if (elapsedField) elapsedField.value = String(Date.now() - loadedAt);

      // Pflichtfelder per HTML5 prüfen
      if (typeof form.reportValidity === 'function' && !form.reportValidity()) {
        return;
      }

      if (errorBox) errorBox.hidden = true;
      if (submitBtn) submitBtn.disabled = true;

      try {
        const response = await fetch(endpoint, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form),
        });

        const result = await response.json().catch(() => ({}));
        if (!response.ok || !result.ok) {
          throw new Error(result.error || 'Übermittlung fehlgeschlagen');
        }

        // Erfolg: Formular ausblenden, Bestätigung zeigen
        form.hidden = true;
        if (sentBox) {
          sentBox.hidden = false;
          sentBox.focus({ preventScroll: true });
          sentBox.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      } catch (error) {
        if (submitBtn) submitBtn.disabled = false;
        if (errorBox) {
          errorBox.hidden = false;
          errorBox.focus?.();
        }
      }
    });
  }

  function boot() {
    document.querySelectorAll('[data-widerruf-form]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
